import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm7 5.41a.5.5 0 0 1 .4-.49l4-.8c.31-.06.6.17.6.49v1.98a.5.5 0 0 1-.4.49L14 9.6V15a3 3 0 1 1-2-2.83V7.41Z",
    fill: "currentColor"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'song');
export default IconComponent;